import { Component, OnInit } from '@angular/core';

import { Title, Meta } from '@angular/platform-browser';

@Component({
  selector: 'app-credits',
  templateUrl: './credits.component.html',
  styleUrls: ['./credits.component.css']
})
export class CreditsComponent implements OnInit {

  constructor(private titleService: Title, private metaService: Meta) { }

  ngOnInit() {
    this.titleService.setTitle('Ticks spaarsysteem l Ticketvoordeel.nl');
    this.metaService.addTags([
      {name: 'keywords', content:'Goedkope vliegtickets turkije. Ticks spaarsysteem'},
      {name: 'description', content: '‘Ticks’ is het spaarsysteem van Ticketvoordeel.nl waarbij u heel eenvoudig ‘Tick credits’ spaart. Met hetzelfde gemak wisselt u deze ‘Tick credits’ in voor een korting op uw vliegticket of een leuk cadeau.'},
      {name: 'robots', content: 'index, follow'}
    ]);
  }

}
